(function ($, Drupal, once) {
  Drupal.behaviors.carteHover = {
    attach: function (context, settings) {
      once('carte', '#block-hyfen-carte', context).forEach(map => {
        const html = document.querySelector('html');
        const svg = map.querySelector("svg");
        const modalContainer = map.querySelector('.modal-container');

        map.addEventListener('click', event => {
          const closeButton = event.target.closest(
            '.modal-region__close, .modal-reseau__close'
          );

          if (!closeButton || !map.contains(closeButton)) return;

          const modal = closeButton.closest('.modal-region, .modal-reseau');

          modal.classList.add('-pre-hidden');
          modal?.setAttribute('aria-hidden', 'true');
          modal?.setAttribute('inert', '');

          setTimeout(() => {
            html.classList.remove('-modal-open');
            modalContainer.classList.remove('-show');
            modal.classList.add('-hidden');
            modal.classList.remove('-pre-hidden');
          }, 400);
        });

        svg.addEventListener('click', event => {
          const target = event.target.closest('.region, .reseau-rect, .reseau-rect-text, .reseau-line');

          if (!target || !svg.contains(target)) return;

          const modalId = target.dataset.region || target.dataset.reseau;

          if (!modalId) return;

          const modal = [...modalContainer.querySelectorAll('[data-region], [data-reseau]')]
            .find(el =>
              el.dataset.region === modalId ||
              el.dataset.reseau === modalId
            );

          if (!modal) return;

          html.classList.add('-modal-open');
          modalContainer.classList.add('-show');
          modal?.setAttribute('aria-hidden', 'false');
          modal?.removeAttribute('inert');
          modal?.classList.remove('-hidden');
        });

        const toggleTag = (target, active) => {
          if (
            !target?.classList.contains('reseau-line') &&
            !target?.classList.contains('reseau-rect') &&
            !target?.classList.contains('reseau-rect-text')
          ) return;

          const data = target.dataset.reseau;
          if (!data) return;

          svg.querySelectorAll(
            `.reseau-line[data-reseau="${data}"], .reseau-rect[data-reseau="${data}"], .reseau-rect-text[data-reseau="${data}"]`
          ).forEach(element => {
            element.classList.toggle('is-hovered', active);
          });
        };

        svg.addEventListener('mouseover', event => {
          toggleTag(event.target, true);
        });

        svg.addEventListener('mouseout', event => {
          toggleTag(event.target, false);
        });
      });
    }
  };

  Drupal.behaviors.mobileCarteZoom = {
    attach: function (context, settings) {
      once('carte-zoom', '#block-hyfen-carte', context).forEach(map => {
        const svg = map.querySelector("svg");
        const btnPlus = map.querySelector(".zoom-in");
        const btnMinus = map.querySelector(".zoom-out");
        const media = window.matchMedia("(max-width: 768px)");

        const defaultViewBox = svg.getAttribute("viewBox").split(" ").map(Number);

        let viewBox = [...defaultViewBox];
        let startX = 0;
        let startY = 0;
        let startViewBox = null;
        let isDragging = false;
        let moved = false;

        svg.style.touchAction = "pan-y";

        function isMobile() {
          return media.matches;
        }

        function isZoomed() {
          return viewBox[2] < defaultViewBox[2] || viewBox[3] < defaultViewBox[3];
        }

        function updateViewBox() {
          svg.setAttribute("viewBox", viewBox.join(" "));
          svg.style.touchAction = isZoomed() ? "none" : "pan-y";
        }

        function resetViewBox() {
          viewBox = [...defaultViewBox];
          updateViewBox();
        }

        function clampViewBox([x, y, w, h]) {
          const [dx, dy, dw, dh] = defaultViewBox;

          const clampedW = Math.min(w, dw);
          const clampedH = Math.min(h, dh);

          return [
            Math.min(Math.max(x, dx), dx + dw - clampedW),
            Math.min(Math.max(y, dy), dy + dh - clampedH),
            clampedW,
            clampedH
          ];
        }

        function zoom(factor) {
          if (!isMobile()) return;

          const [x, y, w, h] = viewBox;
          const newW = w * factor;
          const newH = h * factor;

          viewBox = clampViewBox([
            x + (w - newW) / 2,
            y + (h - newH) / 2,
            newW,
            newH
          ]);

          updateViewBox();
        }

        function getPoint(event) {
          const rect = svg.getBoundingClientRect();

          return {
            x: event.clientX - rect.left,
            y: event.clientY - rect.top
          };
        }

        svg.addEventListener("pointerdown", event => {
          if (!isMobile()) return;

          isDragging = true;
          moved = false;
          startViewBox = [...viewBox];

          const point = getPoint(event);
          startX = point.x;
          startY = point.y;
        });

        svg.addEventListener("pointermove", event => {
          if (!isMobile() || !isDragging) return;

          const point = getPoint(event);

          const dx = (point.x - startX) * (viewBox[2] / svg.clientWidth);
          const dy = (point.y - startY) * (viewBox[3] / svg.clientHeight);

          if (!moved && (Math.abs(point.x - startX) > 5 || Math.abs(point.y - startY) > 5)) {
            moved = true;
            svg.setPointerCapture(event.pointerId);
          }

          if (moved) {
            viewBox = clampViewBox([
              startViewBox[0] - dx,
              startViewBox[1] - dy,
              viewBox[2],
              viewBox[3]
            ]);
            updateViewBox();
          }
        });

        svg.addEventListener("pointerup", event => {
          isDragging = false;
          if (svg.hasPointerCapture(event.pointerId)) {
            svg.releasePointerCapture(event.pointerId);
          }
        });

        svg.addEventListener("pointercancel", event => {
          isDragging = false;
          if (svg.hasPointerCapture(event.pointerId)) {
            svg.releasePointerCapture(event.pointerId);
          }
        });

        btnPlus.addEventListener("click", event => {
          event.stopPropagation();
          zoom(0.8);
        });

        btnMinus.addEventListener("click", event => {
          event.stopPropagation();
          zoom(1.25);
        });

        media.addEventListener("change", () => {
          isDragging = false;

          if (!isMobile()) {
            resetViewBox();
          }
        });
      });
    }
  };
})(jQuery, Drupal, once);
